import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

export const UPDATE_RESPONDENT_MUTATE = gql`
  mutation updateRespondent($input: UpdateRespondentInput!) {
    updateRespondent(input: $input) {
      respondent {
        id
        email
        firstName
        lastName
        gender
        locale
        type
        assessmentType
        targetJob {
          id
          name
        }
        notes
      }
    }
  }
`;

const updateRespondentDetails = graphql(UPDATE_RESPONDENT_MUTATE, { name: 'updateRespondent' });

const LOCALE_QUERY = gql`
  query viewer {
    activeLocales
  }
`;

const localeList = graphql(LOCALE_QUERY, { name: 'localeList' });

export default compose(
  updateRespondentDetails,
  localeList,
);
